import { QuotationHistorical } from '../../../../../shared/types/modules/quotation';

export interface QuotationHistoricalProps {
    historical: QuotationHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createdAt: 'Fecha de creación',
    callId: 'Call ID',
    channel: 'Canal',
    typeQuotation: 'Tipo de cotización',
    bouquet: 'Ramo',
    status: 'Estado',
    typification: 'Tipificación',
    subtypification: 'Subtipificación',
    stage: 'Etapa',
    policyNumber: 'Número de póliza',
    policyDate: 'Fecha de expedición de póliza',
    motive: 'Motivo',
    plate: 'Placa',
    amount: 'Monto',
    observation: 'Observación',
};
